import { Color } from 'chroma-js'

// Chroma JS manipulators
export const lighten = (color: Color, hslPercent: number) =>
  color.set('hsl.l', color.get('hsl.l') + hslPercent)
export const darken = (color: Color, hslPercent: number) =>
  lighten(color, -hslPercent)
